import React, {useContext, useEffect, useRef} from 'react';
import {UserContext} from '../common/UserContext';
import Button from '../common/Button';
import {ChevronRightIcon} from '../common/icons/';
import {BrandContext} from "../common/BrandContext";

import Tooltip from "../common/Tooltip";
import {useScreenMode} from "../common/context/ScreenModeContext";

const SeriesSelect = props => {
    const {className, visible, compressed, onClick} = props;
    const brandConfig = useContext(BrandContext);
    const {user, setUser} = useContext(UserContext);
    const buttonRef = useRef();
    const {smallScreenMode} = useScreenMode();
    const keyListener = e => {
        if (e.key === 'ArrowRight' || e.key === 'Enter') {
            if (e.key === 'ArrowRight') buttonRef.current.click();
            const seriesDrawer = document.getElementsByClassName('ch-series-drawer-content')[0];
            setTimeout(() => {
                seriesDrawer.querySelectorAll('[tabindex]:not([tabindex="-1"])')[0].focus();
            }, 1);
        }
    }

    useEffect(() => {
        buttonRef.current.addEventListener('keydown', keyListener);
        return () => {
            buttonRef.current.removeEventListener('keydown', keyListener);
        }
    }, []);

    return (
        <div className={className ? className : ''}>
            <Button ref={buttonRef} className={'ch-series-select ch-ignore-click-outside'} aria-haspopup = 'menu' aria-expanded={visible} onClick={onClick}>
                {(!compressed || smallScreenMode) &&
                    <span className="ch-series-select-title">
                        {!brandConfig.disableConcepts && (
                            <>Course Content</>
                        )}

                        {brandConfig.disableConcepts && (
                            <>{user.syllabusName}</>
                        )}
                    </span>
                }
                {compressed &&
                    <Tooltip title={'Course Content'} placement="bottom" enterNextDelay={100} disableInteractive>
                        <span className={'ch-series-select-icon' + (visible ? ' pull-out-l' :'')}>
                            <ChevronRightIcon />
                        </span>
                    </Tooltip>
                }
                {!compressed &&
                    <span className={'ch-series-select-icon' + (visible ? ' pull-out-l' :'')}>
                        <ChevronRightIcon />
                    </span>
                }
            </Button>
        </div>
    );
}

export default SeriesSelect;